module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "changelog-modal",
      "height": "auto",
      "minHeight": "300",
      "classes": ['v--modal', 'vue-dialog'],
      "width": _vm.width,
      "pivot-y": 0.3,
      "adaptive": true,
      "scrollable": true,
      "clickToClose": false
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('vue-markdown', [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn __red",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n      Close\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-691b86e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/Changelog.vue
// module id = 386
// module chunks = 1